<template>
  <div>
    <!-- LOADING -->
    <div v-if="busy" class="d-flex flex-column align-items-center mt-8 py-6">
      <spring-spinner
        :animation-duration="1500"
        :size="60"
        color="#bf0000"
        class="mx-auto"
      />
      <p class="primary--text mx-auto font-weight-bold mt-6">
        در حال بارگذاری...
      </p>
    </div>
    <div v-else>
      <pie-header :role="role" :allPies="allPies" />

      <v-card class="custom-table">
        <v-card class="border-none">
          <v-row class="mt-0 border-none mb-2">
            <v-col class="d-flex mt-0" cols="12" md="6">
              <div><h4 class="mt-2">گزارش صندوق مالی</h4></div>
            </v-col>
            <v-col cols="12" md="6" class="pe-0 text-end">
              <v-btn
                class="primary mt-2 white--text pa-5 me-1 mt-sm-2 mt-8"
                @click="wellBalance = true"
                width="180px"
              >
                تاریخچه تراکنش‌های صندوق
              </v-btn>
              <v-btn
                class="pa-5 mt-2 border flex-row me-1"
                depressed
                style="color: green"
                @click="$refs.WellLogExcel.$el.click()"
                width="180px"
                :disabled="!WellLogData.length"
              >
                <v-icon color="green" class="me-1"
                  >mdi-file-excel-outline</v-icon
                >
                خروجی اکسل
              </v-btn>
              <vue-excel-xlsx
                v-show="false"
                ref="WellLogExcel"
                :data="WellLogData"
                :columns="excelFields"
                :file-name="`صندوق مالی_${currentDate}`"
                :sheet-name="'صندوق مالی'"
              >
                دریافت اکسل
              </vue-excel-xlsx>
            </v-col>
          </v-row>
        </v-card>

        <!-- end-header -->
        <div class="custom-table pt-0">
          <v-data-table
            class="bold"
            :mobile-breakpoint="0"
            :headers="headers"
            :items="WellLogData"
            hide-default-footer
            :page.sync="CurrentPage"
            :items-per-page="PerPage"
            item-key="name"
          >
            <template slot="no-data">
              <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <span>{{ item.description ? item.description : "-" }}</span>
            </template>
            <!--expand  -->
            <!-- <template v-slot:[`item.data-table-expand`]="{ item, isExpanded }">
              <span
                v-if="item.members.length > 1"
                class="pointer"
                @click="handleExpansion(item, isExpanded)"
              >
                <v-icon>mdi-plus-thick</v-icon>
              </span>
            </template> -->
            <!-- <template v-slot:[`expanded-item`]="{ headers, item }">
              <td :colspan="headers.length" class="box">
                <div class="mt-4 ms-12">
                  <v-row class="py-4">
                    <v-col cols="2">نام</v-col>
                    <v-col cols="1">مقدار</v-col>
                    <v-col cols="1">قطعات</v-col>
                  </v-row>
                </div>
                <v-row
                  class="my-4 ms-10"
                  v-for="(item2, index) in item.members"
                  :key="index"
                >
                  <v-col cols="2">
                    <div>{{ item2.userName }}</div>
                  </v-col>
                  <v-col cols="1">
                    <div>{{ item2.amount }} ریال</div>
                  </v-col>
                  <v-col cols="1">
                    <div>{{ item2.slices }}</div>
                  </v-col>
                </v-row>
              </td>
            </template> -->
            <!-- end-expand -->

            <!-- delete-icon -->
            <!-- <template v-slot:[`item.action1`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="primary"
                ><span
                  @click="openDialog(item)"
                  class="pointer"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="white--text">mdi-trash-can</v-icon></span
                ></v-btn
              >
            </template>
            <span> حذف معامله</span>
          </v-tooltip>
        </template> -->
            <!-- end-delete-icon -->
            <template v-slot:[`item.userName`]="{ item }">
              <!-- <span >{{ item.userName }}</span> -->
              <span :style="'color:' + item.funderColor">{{
                item.userName == "" ? "-" : item.userName
              }}</span>
            </template>
            <template v-slot:[`item.addedAmount`]="{ item }">
              <span>{{
                item.addedAmount != "-"
                  ? Number(item.addedAmount).toLocaleString() + " ریال"
                  : "-"
              }}</span>
            </template>
            <template v-slot:[`item.withdrawnAmount`]="{ item }">
              <span>{{
                item.withdrawnAmount != "-"
                  ? Number(item.withdrawnAmount).toLocaleString() + " ریال"
                  : "-"
              }}</span>
            </template>
          </v-data-table>
          <v-pagination
            v-model="CurrentPage"
            :length="Math.ceil(totalRows / PerPage)"
            :total-visible="5"
            prev-icon="mdi-arrow-left"
            next-icon="mdi-arrow-right"
            class="mt-8"
          ></v-pagination>
        </div>
      </v-card>

      <!-- delete-v-dialog -->
      <!-- <v-dialog v-model="removeDialog" width="500">
      <v-card class="px-0">
        <v-card-title class="mb-4"> حذف معامله مالی </v-card-title>
        <v-card-text>
          <p>آیا می‌خواهید معامله مالی حذف شود؟</p>
          <v-row class="mt-5">
            <v-col class="d-flex flex-sm-row flex-column justify-space-between">
              <v-btn class="primary white--text mx-sm-0 mb-sm-0 mb-4">
                <v-icon small>mdi-check-bold</v-icon>
                بله
              </v-btn>
              <v-btn
                class="primary white--text mx-sm-0"
                @click="removeDialog = false"
              >
                <v-icon small>mdi-close-thick</v-icon>
                خیر
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->
      <!-- end-delete-v-dialog -->
      <!-- edit-v-dialog -->
      <v-dialog v-model="editDialog" v-if="editDialog" width="700">
        <v-card class="px-0">
          <div
            v-if="tableLoading"
            class="d-flex flex-column align-items-center mt-8 py-6"
          >
            <spring-spinner
              :animation-duration="1500"
              :size="60"
              color="#bf0000"
              class="mx-auto"
            />
            <p class="primary--text mx-auto font-weight-bold mt-6">
              در حال بارگذاری...
            </p>
          </div>

          <div v-else>
            <v-card-title class="mb-4">ویرایش معامله مالی </v-card-title>
            <v-card-text>
              <v-row class="ms-1">
                <h3>تاریخ</h3>
                <h3 class="red--text">*</h3></v-row
              >
              <span id="theDate3">
                <v-text-field
                  outlined
                  dense
                  class="mt-4"
                  v-model="selected.date3"
                >
                </v-text-field
              ></span>
              <date-picker
                element="theDate3"
                v-model="selected.date3"
                color="#bf0000"
              ></date-picker>
              <div v-if="selected.addedAmount == 0">
                <v-row class="mb-1 ms-1"
                  ><h3 class="ms-1">نوع کار</h3>
                  <h3 class="red--text">*</h3>
                </v-row>
                <v-select
                  outlined
                  dense
                  :items="projectsList"
                  v-model="workType"
                ></v-select>
                <h3 class="ms-1">مبلغ</h3>
                <v-text-field outlined dense class="mt-2"></v-text-field>
                <h3 class="ms-1">توضیحات</h3>
                <div class="">
                  <v-text-field outlined> </v-text-field>
                </div>
              </div>
              <div v-if="selected.addedAmount != 0">
                <!-- <v-text-field outlined dense class="mt-4"> </v-text-field> -->
                <h3 class="ms-1">توضیحات</h3>
                <v-textarea outlined></v-textarea>
                <h3 class="ms-1">مبلغ سرمایه‌گذاری</h3>
                <v-text-field outlined dense class="mt-2"></v-text-field>
                <h3 class="ms-1">سرمایه‌گذار</h3>
                <div>
                  <v-select outlined dense :items="items"> </v-select>
                </div>
                <v-row class="mb-1 ms-1"
                  ><h3>دستمزد یابنده سرمایه‌گذار (اختیاری)</h3>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="pointer" v-bind="attrs" v-on="on">
                        <v-icon class="black--text ms-1"
                          >mdi-help-circle-outline</v-icon
                        ></span
                      >
                    </template>
                    <span>شخصی که یابنده سرمایه‌گذار است.</span>
                  </v-tooltip></v-row
                >
                <div>
                  <v-text-field outlined dense> </v-text-field>
                </div>
              </div>

              <v-row class="mt-5">
                <v-col
                  class="d-flex flex-sm-row flex-column justify-space-between"
                >
                  <v-btn
                    class="primary white--text mx-sm-0 mb-sm-0 mb-4"
                    :disabled="
                      !selected.date && selected.addedAmount == 0
                        ? !selected.workType
                        : ''
                    "
                  >
                    <v-icon small>mdi-check-bold</v-icon>
                    به‌روزرسانی
                  </v-btn>
                  <v-btn
                    class="primary white--text mx-sm-0"
                    @click="
                      editDialog = false;
                      selected = {};
                    "
                  >
                    <v-icon small>mdi-close-thick</v-icon>
                    انصراف
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <!-- end-edit-dialog -->

      <!-- WellBalance -->
      <v-dialog v-model="wellBalance" width="450" class="bold">
        <v-card class="bold pa-sm-4 pa-1 pb-4">
          <v-card-title class="bold">صندوق مالی</v-card-title>
          <v-card-text class="bold">
            <v-data-table
              class="border bold"
              :mobile-breakpoint="0"
              :headers="headers1"
              :items="WellBalanceData"
              hide-default-footer
              :page.sync="CurrentPage"
            >
              <template slot="no-data">
                <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
              </template>
              <template v-slot:[`item.userName`]="{ item }">
                <span :style="'color:' + item.funderColor">{{
                  item.userName
                }}</span>
              </template>
              <template v-slot:[`item.balance`]="{ item }">
                {{
                  item.balance
                    ? Number(item.balance).toLocaleString() + " ریال"
                    : "-"
                }}
              </template>
              <template slot="body.append">
                <tr>
                  <td class="primary--text text-start">
                    <span>مجموع</span>
                  </td>
                  <td class="primary--text text-start">
                    {{ Number(total).toLocaleString() + " ریال" }}
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-row>
              <v-col cols="12">
                <v-btn
                  width="100% "
                  class="primary white--text mt-2"
                  @click="wellBalance = false"
                >
                  بستن
                </v-btn>
              </v-col></v-row
            >
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end-WellBalance -->
    </div>
  </div>
</template>

<script>
import { SpringSpinner } from "epic-spinners";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import utilities from "./../../mixins/utilities";
const PieHeader = () => import("@/components/PieHeader");
export default {
  mixins: [utilities],
  components: {
    SpringSpinner,
    datePicker: VuePersianDatetimePicker,
    PieHeader,
  },
  data() {
    return {
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      allPies: [],
      removeDialog: false,
      wellBalance: false,
      editDialog: false,
      CurrentPage: 1,
      PerPage: 10,
      totalRows: "",
      selected: {},
      tableLoading: false,
      role: "",
      date3: "",
      workType: "",
      newItem: {
        dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
        repeatCont: "off",
        amount: 0,
        receiveCont: 0,
        description: "",
      },
      datePicker: VuePersianDatetimePicker,
      payment: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      fund: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
        fundUserId: "",
        finderId: "",
      },
      drawFundData: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      excelFields: [
        { field: "date", label: "تاریخ" },
        { field: "userName", label: "نام" },
        { field: "description", label: "توضیحات" },
        { field: "addedAmount", label: "سرمایه افزوده‌شده" },
        { field: "withdrawnAmount", label: "سرمایه کسر‌‌شده" },
      ],
      headers: [
        { text: "تاریخ", value: "date" },
        { text: "نام", value: "userName" },
        { text: "توضیحات", value: "description" },
        { text: "سرمایه افزوده‌‌‌شده", value: "addedAmount" },
        { text: "سرمایه کسر‌‌شده", value: "withdrawnAmount" },
        { text: "", value: "action1", sortable: false },
        { text: "", value: "action2", sortable: false },
      ],
      headers1: [
        { text: "نام", value: "userName" },
        { text: "مبلغ", value: "balance" },
      ],
      WellLogData: [],
      // expanded: [],
      WellBalanceData: [],
    };
  },
  methods: {
    goToPie(item) {
      this.$router.push("/home/" + item.id);
      localStorage.setItem("selectedPie", item.id);
      localStorage.setItem("role", item.userRole);
      localStorage.setItem("restriction", item.restriction);
      localStorage.setItem("ownerId", item.pieUserId);
    },
    setRepeatTime() {
      if (this.newItem.repeatCont == "daily") {
        this.newItem.repeatDate = moment(new Date())
          .add(1, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "weekly") {
        this.newItem.repeatDate = moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "biweekly") {
        this.newItem.repeatDate = moment(new Date())
          .add(14, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "monthly") {
        this.newItem.repeatDate = moment(new Date())
          .add(30, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "annually") {
        this.newItem.repeatDate = moment(new Date())
          .add(365, "days")
          .format("jYYYY/jMM/jDD");
      }
    },
    changePie(item) {
      this.$router.push("/home/" + item.id);
      localStorage.setItem("selectedPie", item.id);
      this.getInfo();
    },
    openDialog(item) {
      this.removeDialog = true;
    },
    openEditDialog(item1) {
      this.selected = item1;
      this.editDialog = true;
    },
    ViewWellBalance(item2) {},
    // handleExpansion(item, state) {
    //   const itemIndex = this.expanded.indexOf(item);

    //   state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    // },
    getData() {
      this.busy = true;
      this.$http
        .get(
          this.baseUrl +
            "/" +
            this.role +
            "/fundflows/list/" +
            this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.WellLogData = res.data.fundFlows;
            this.totalRows = res.data.fundFlows.length;
            this.WellBalanceData = res.data.fundFlowsForUsers;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
  },
  computed: {
    computedCurrentPie() {
      if (this.allPies.length) {
        let pie;
        pie = this.allPies.filter((x) => x.id == this.$route.params.id)[0];
        return pie;
      }
    },
    total() {
      let sum = 0;
      this.WellBalanceData.forEach((item) => {
        sum += Number(item.balance);
      });

      return sum;
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.getData();
    this.getAllPies();
  },
};
</script>
